import * as types from 'modules/checklists/actionTypes';
import type { CreateSuccessAction, FetchChecklistSuccessAction, SetDisplayedLanguagesAction, UpdateSuccessAction } from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsLanguagesReducer = Array<string>;

const initialState: ChecklistUiDetailsLanguagesReducer = [];

const updateFromChecklists = (
  _: ChecklistUiDetailsLanguagesReducer,
  { payload }: FetchChecklistSuccessAction | UpdateSuccessAction | CreateSuccessAction
): ChecklistUiDetailsLanguagesReducer => payload.languages ?? [];

const setLanguages = (
  _: ChecklistUiDetailsLanguagesReducer,
  { payload: languages }: SetDisplayedLanguagesAction
): ChecklistUiDetailsLanguagesReducer => languages;

const reset = (): ChecklistUiDetailsLanguagesReducer => initialState;

export default createReducer(initialState, {
  [types.SET_IS_NEW]: reset,
  [types.FETCH_SUCCESS]: updateFromChecklists,
  [types.UPDATE_SUCCESS]: updateFromChecklists,
  [types.CREATE_SUCCESS]: updateFromChecklists,
  [types.SET_DISPLAYED_LANGUAGES]: setLanguages,
});
